import "core-js/modules/es.number.constructor.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '@/assets/discuss/page-remove.png';
import _imports_1 from '@/assets/discuss/page-last.png';
import _imports_2 from '@/assets/discuss/page-next.png';
import _imports_3 from '@/assets/discuss/page-add.png';
var _hoisted_1 = {
  class: "paging"
};
var _hoisted_2 = {
  class: "nums"
};
import { MessagePlugin } from 'tdesign-vue-next';

/* 变量 */

export default {
  __name: 'Paging',
  props: {
    current: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    justSwitch: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:current', 'removePage', 'addPage', 'switchPage'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 工具 */
    var props = __props;
    var emit = __emit;

    /* 事件 */
    var handleRemove = function handleRemove() {
      if (props.total <= 1) return MessagePlugin.warning('至少保留一页！');
      emit('removePage');
    };
    var changeLast = function changeLast() {
      if (props.total === 0) return MessagePlugin.warning('已经是第一页！');
      if (props.current > 1) {
        emit('update:current', props.current - 1);
        emit('switchPage');
      } else {
        MessagePlugin.warning('已经是第一页！');
      }
    };
    var changeNext = function changeNext() {
      if (props.total === 0) return MessagePlugin.warning('已经是最后一页！');
      if (props.current < props.total) {
        emit('update:current', props.current + 1);
        emit('switchPage');
      } else {
        MessagePlugin.warning('已经是最后一页！');
      }
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!__props.justSwitch ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _imports_0,
        alt: "",
        onClick: handleRemove
      })) : _createCommentVNode("", true), _createElementVNode("img", {
        src: _imports_1,
        alt: "",
        onClick: changeLast
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(__props.current) + "/" + _toDisplayString(__props.total), 1)]), _createElementVNode("img", {
        src: _imports_2,
        alt: "",
        onClick: changeNext
      }), !__props.justSwitch ? (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: _imports_3,
        alt: "",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return emit('addPage');
        })
      })) : _createCommentVNode("", true)]);
    };
  }
};